import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { InheritanceHelper } from "%/dynamic-component-editor/classes/inheritance-helper";
import StaticLayoutDirection from "%/dynamic-component-editor/options/static-layout-direction";

export default class LayoutAlign extends BaseOption {
  static label = "Align";

  static userInterfaceComponent = (optionsConfig, themeId, state) => {

    let layoutDirection = "vertical";

    if (state) {
      layoutDirection = InheritanceHelper.getInheritedOptionValue(new StaticLayoutDirection(), state, optionsConfig);
    }

    let options = [
      {
        icon: "align-left",
        value: "start",
      },
      {
        icon: "align-center",
        value: "center",
      },
      {
        icon: "align-right",
        value: "end",
      },
    ];

    if (layoutDirection === "horizontal") {
      options = [
        {
          icon: "align-top",
          value: "start",
        },
        {
          icon: "align-middle",
          value: "center",
        },
        {
          icon: "align-bottom",
          value: "end",
        },
      ];
    }

    return {
      component: inspectorTools.RADIO_BAR,
      iconSize: 24,
      props: {
        options,
      },
    };
  };

  static defaultValue = "start";

  static getValue(option) {
    let value = option;

    if (typeof option !== "string") {
      value = option.value;
    }

    return value;
  }
}
